import mixpanel from 'mixpanel-browser';
import {AppSteps} from '-/components/general/AppData';

class MixpanelService {
    constructor() {
        if (!MixpanelService.instance) {
            MixpanelService.instance = this;
        }
        return MixpanelService.instance;
    }

    setName(name) {
        mixpanel.people.set({name});
    }

    navNextOrBack(step) {
        const appStep = AppSteps[step];
        if (appStep) {
            mixpanel.track(`${appStep.title} Page`);
        }
    }

    validated(Success, Type) {
        mixpanel.track('Validation', {Type, Success});
    }

    stipImageUpload(Success, Error) {
        mixpanel.track('Stip Image Upload', {Success, Error});
    }
}

export default new MixpanelService();
